// src/features/dashboard/components/charts/FeedbackTypeChart/FeedbackTypeChart.jsx
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";

import StackedBarChart from "../../../../../components/Charts/StackedBarChart";
import ChartWrapper from "../../../../../components/common/ChartWrapper/ChartWrapper";
import ChartHeader from "../../../../../components/common/ChartHeader/ChartHeader";
import { transformFeedbackDistData } from "../../../utils/chartTransformers";

import "../dashboardCharts.scss";

const FeedbackTypeChart = () => {
  const { feedbackDist, feedbackDistFetching } = useSelector(
    (s) => s.dashboard,
  );
  const chartData = useMemo(
    () => transformFeedbackDistData(feedbackDist),
    [feedbackDist],
  );
  const isEmpty = !chartData.categories.length;

  return (
    <Box className="chart-card animate-card">
      <ChartHeader icon={ChatRoundedIcon} title="Feedback Type Distribution" />
      <ChartWrapper
        isLoading={feedbackDistFetching}
        isEmpty={isEmpty}
        height="394px"
      >
        <StackedBarChart data={chartData} />
      </ChartWrapper>
    </Box>
  );
};

export default FeedbackTypeChart;
